import { render, staticRenderFns } from "./preview-testPaper.vue?vue&type=template&id=3b68e2ce&scoped=true&"
import script from "./preview-testPaper.vue?vue&type=script&lang=ts&"
export * from "./preview-testPaper.vue?vue&type=script&lang=ts&"
import style0 from "./preview-testPaper.vue?vue&type=style&index=0&id=3b68e2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b68e2ce",
  null
  
)

export default component.exports